export function isPresent(str?: any): boolean {
  return !!(str && str !== '');
}

export function extractQuestionKeys(questionData: QuestionData[]) {
  const keys: string[] = [];
  if (!questionData) {
    return keys;
  }
  questionData.forEach((question) => {
    if (question.inputs) {
      question.inputs.forEach((input) => {
        keys.push(input.key);
      });
    }
  });
  return keys;
}

export function countQuestions(questionData: QuestionData[], excludes: string[] = []) {
  var numQuestions = 0;
  questionData.forEach((question) => {
    if (question.inputs) {
      question.inputs.forEach((input) => {
        if (!excludes.includes(input.key)) {
          numQuestions++;
        }
      });
    }
  });
  return numQuestions;
}

export function countQuestionsInSection(questionData: QuestionData[], section, excludes: string[] = []) {
  var numQuestions = 0;
  questionData.forEach((question) => {
    if (question.section === section && question.inputs) {
      question.inputs.forEach((input) => {
        if (!excludes.includes(input.key)) {
          numQuestions++;
        }
      });
    }
  });
  return numQuestions;
}

export function addQuestionSectionData(questionData: QuestionData[]) {
  var sectionIndex = 1;
  questionData.forEach((question, index) => {
    questionData[index].section = sectionIndex;
    if (question.key.includes('complete')) {
      sectionIndex++;
    }
  });
  return questionData;
}

export function prettyNumber(currency: number | string) {
  let x = (currency + '').split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? '.' + x[1] : '';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }

  if (x2.length === 2) {
    x2 += '0';
  }
  if (x2.length === 0) {
    x2 += '.00';
  }
  return x1 + x2;
}

export function prePending(number: number | string, count: number) {
  return String(number).padStart(count, '0');
}

export function getSuffix(n) {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return (s[(v - 20) % 10] || s[v] || s[0]);
}

export function reverseObject(obj: Record<string, string>) {
  const ret = {}
  Object.keys(obj).forEach(key => {
    ret[obj[key]] = key
  })
  return ret
}

export const TIMEOUT_ERROR = 'TIMEOUT_ERROR'

export function waitToReject(ms: number): Promise<void> {
  return new Promise((_resolve, reject) => setTimeout(() => reject(new Error(TIMEOUT_ERROR)), ms))
}

const stateNames = {
  AL: 'Alabama', AK: 'Alaska', AS: 'American Samoa', AZ: 'Arizona', AR: 'Arkansas',
  CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
  FM: 'Federated States Of Micronesia', FL: 'Florida', GA: 'Georgia', GU: 'Guam', HI: 'Hawaii',
  ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky',
  LA: 'Louisiana', ME: 'Maine', MH: 'Marshall Islands', MD: 'Maryland', MA: 'Massachusetts',
  MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska',
  NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York',
  NC: 'North Carolina', ND: 'North Dakota', MP: 'Northern Mariana Islands', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PW: 'Palau', PA: 'Pennsylvania', PR: 'Puerto Rico',
  RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
  UT: 'Utah', VT: 'Vermont', VI: 'Virgin Islands', VA: 'Virginia', WA: 'Washington',
  WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', BS: 'British Columbia', AB: 'Alberta',
  ON: 'Ontario', QB: 'Quebec'
}

export const getStateName = (state: string) => stateNames[state];
